import { FC } from "react";

import type { OrganizationAssistantResendDonorEmailCard } from "@simplyk/common";

import { formatToolAmount, formatToolDate } from "../../helpers/formatToolValues";
import { DetailRow } from "../DetailRow/DetailRow";

import { useLocaleContext } from "@/common/contexts/LocaleContext";
import { useTranslate } from "@/common/hooks/useTranslate";

interface ResendDetailsProps {
  card: OrganizationAssistantResendDonorEmailCard;
}

export const ResendDetails: FC<ResendDetailsProps> = ({ card }) => {
  const { t } = useTranslate();
  const { isoLocale } = useLocaleContext();
  return (
    <>
      <DetailRow label={t("dashboard", "organizationAssistant.approval.donorEmailLabel")} value={card.donorEmail} />
      <DetailRow
        label={t("dashboard", "organizationAssistant.approval.paymentLabel")}
        value={t("dashboard", "organizationAssistant.approval.paymentValue", {
          amount: formatToolAmount(card.amount, card.currency, isoLocale),
          date: formatToolDate(card.createdAt, isoLocale),
        })}
      />
      {card.formName && (
        <DetailRow label={t("dashboard", "organizationAssistant.approval.campaignLabel")} value={card.formName} />
      )}
    </>
  );
};
